<mat-card>
  <ng-container [ngSwitch]="typeformNumber">
    <ng-container *ngSwitchCase="'1'"
      ><app-typeform-response-renderer
        *ngIf="cart.typeform1?.data"
        [response]="cart.typeform1.data"
      ></app-typeform-response-renderer
    ></ng-container>
    <ng-container *ngSwitchCase="'2'"
      ><app-typeform-response-renderer
        *ngIf="cart.typeform2?.data"
        [response]="cart.typeform2.data"
      ></app-typeform-response-renderer
    ></ng-container>
  </ng-container>
</mat-card>
